<template>
  <div>
    <customer-detail-form-modal
      ref="customer-detail-form-modal"
      v-if="showCustomerDetailFormModal"
      :CustomerId="CustomerId"
      :PhoneNumber="PhoneNumber"
      :RerunReportCallback="RerunReportCallback"
      :CallbackRecord="CallbackRecord"
      :CustomerSource="CustomerSource"
    ></customer-detail-form-modal>
    <contact-info-form-modal
      ref="contact-info-form-modal"
      v-if="showContactInfoFormModal"
      :contactInfoCustomerId="CustomerId"
      :contactInfoId="ContactInfoModalId"
      :contactInfoType="ContactInfoType"
      :contactInfoDetails="ContactInfoDetails"
      :contactInfoMessage="ContactInfoMessage"
      :RerunReportCallback="RerunReportCallback"
      :CallbackRecord="CallbackRecord"
      :CallTrackingNumberSource="CallTrackingNumberSource"
    ></contact-info-form-modal>
    <address-form-modal
      ref="address-form-modal"
      v-if="showAddressFormModal"
      :addressCustomerId="CustomerId"
      :addressId="AddressModalId"
    ></address-form-modal>
    <other-info-form-modal
      ref="other-info-form-modal"
      v-if="showOtherInfoFormModal"
      :otherInfoCustomerId="CustomerId"
      :otherInfoId="OtherInfoModalId"
    ></other-info-form-modal>
    <ContactMergeModal
      ref="contact-merge-modal"
      :ContactInfoDetails="ContactInfoDetails"
      :CustomerSource="CustomerSource"
      v-if="showContactMergeModal"
    ></ContactMergeModal>
    <AppointmentFormModal
      ref="appointment-form-modal"
      v-if="showAppointmentFormModal"
      :appointmentId="AppointmentModalId"
      :appointmentCustomerId="CustomerId"
      :appointmentAllDay="AppointmentModalAllDay"
      :appointmentStart="AppointmentModalStart"
      :appointmentEnd="AppointmentModalEnd"
    ></AppointmentFormModal>
  </div>
</template>

<script>
const CustomerDetailFormModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-CustomerDetailFormModal" */ `./CustomerDetailFormModal.vue`
  );
const ContactInfoFormModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ContactInfoFormModal" */ `./ContactInfoFormModal.vue`
  );
const OtherInfoFormModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-OtherInfoFormModal" */ `./OtherInfoFormModal.vue`
  );
const AddressFormModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-AddressFormModal" */ `./AddressFormModal.vue`
  );
const AppointmentFormModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-AppointmentFormModal" */ `./AppointmentFormModal.vue`
  );
const ContactMergeModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ContactMergeModal" */ `./ContactMergeModal.vue`
  );

export default {
  name: "CustomerEditorModals",
  components: {
    CustomerDetailFormModal,
    ContactInfoFormModal,
    OtherInfoFormModal,
    AddressFormModal,
    AppointmentFormModal,
    ContactMergeModal
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      ContactInfoModalId: -1,
      ContactInfoDetails: null,
      ContactInfoMessage: null,
      OtherInfoModalId: -1,
      AddressModalId: -1,
      AccountId: 0,
      CustomerId: 0,
      PhoneNumber: null,
      CustomerSource: null,
      showCustomerDetailFormModal: false,
      showContactInfoFormModal: false,
      showOtherInfoFormModal: false,
      showAddressFormModal: false,
      showAppointmentFormModal: false,
      showContactMergeModal: false,
      AppointmentModalId: -1,
      AppointmentModalCustomerId: null,
      AppointmentModalAllDay: false,
      AppointmentModalStart: null,
      AppointmentModalEnd: null,
      RerunReportCallback: null,
      CallbackRecord: null,
      CallTrackingNumberSource: null
    };
  },
  computed: {},
  created() {},
  methods: {}
};
</script>

<style scoped lang="stylus"></style>
